export default "__VITE_ASSET__024ac61e__"